import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import { FC } from "react"
import { SectionProps } from "./SectionType"

const SectionTen: FC<SectionProps> = ({ children, backgroundColor = "rgba(255, 246, 241, 1)" }) => {
  return (
    <section
      style={{
        height: "min-content",
        minHeight: "min-content",
        padding: "24px",
        backgroundColor: backgroundColor,
      }}
      className={classNames(styles.sectionMedium, styles.sectionTen)}
    >
      {children}
    </section>
  )
}

export default SectionTen
